import { render, staticRenderFns } from "./GraficDonut.vue?vue&type=template&id=5a194014&scoped=true&"
import script from "./GraficDonut.vue?vue&type=script&lang=js&"
export * from "./GraficDonut.vue?vue&type=script&lang=js&"
import style0 from "./GraficDonut.vue?vue&type=style&index=0&id=5a194014&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a194014",
  null
  
)

export default component.exports